import React, { useContext, useEffect } from 'react';
import { WidthContext } from '../../WidthContext';
import './inlinePhotos.scss';
import { inlinePhotoData } from './inlinePhotosData';

function InlinePhotos({ index, inlineRef }) {
  const { viewSize } = useContext(WidthContext);
  const { srcD, srcM, caption, size } = inlinePhotoData[index];
  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.3) {
            entry.target.style.transform = 'scale(1)';
          }
        });
      },
      { threshold: [0, 0.3, 1] }
    );
    observer.observe(inlineRef.current);
  }, [inlineRef]);

  return (
    <figure className={`inline inline--${size}`}>
      <div className={`inline__wrapper inline__wrapper--${size}`}>
        <img
          className={`inline__img inline__img--${size}`}
          alt=""
          src={viewSize === 'large' ? srcD : srcM}
          ref={inlineRef}
        ></img>
      </div>
      {caption && (
        <figcaption className={`inline__caption inline__caption--${size}`}>{caption}</figcaption>
      )}
    </figure>
  );
}

export default InlinePhotos;
